(function () {
  var TABLE_ID = 'diamondtable';
  var tableEl = null;
  var nextPageEl = null;
  var lastFetchedPage = 1;
  var totalPages = 1;
  var inFlight = false;
  var observer = null;

  var waitAttempts = 0;
  var MAX_WAIT_ATTEMPTS = 25; // ~5s; if not found by then this isn't a legacy diamond page
  function waitForTable() {
    tableEl = document.getElementById(TABLE_ID);
    nextPageEl = document.getElementById('nextpage');
    if (tableEl && nextPageEl) {
      console.log('[auto-paginate] booting; #diamondtable + #nextpage found');
      setupObserver();
      return;
    }
    if (++waitAttempts >= MAX_WAIT_ATTEMPTS) return; // not a legacy diamond page; bail silently
    setTimeout(waitForTable, 200);
  }

  function setupObserver() {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        tryNext();
      });
    }, { rootMargin: '600px 0px' });
    observer.observe(nextPageEl);
    setInterval(tryNext, 2500);
  }

  var stopped = false;
  var paused  = false;
  // Cap auto-loading so we don't bloat the DOM with 100k+ cards.
  // After this many auto-loaded pages, switch to a manual "Load more" button.
  var AUTO_PAGES = 10;

  function stop(why) {
    stopped = true;
    if (observer) observer.disconnect();
    removeLoadMore();
    console.log('[auto-paginate] stopped:', why);
  }

  function pauseForManualLoad() {
    paused = true;
    if (observer) observer.disconnect();
    showLoadMore();
  }

  function showLoadMore() {
    if (document.getElementById('sp-load-more-wrap')) return;
    var wrap = document.createElement('div');
    wrap.id = 'sp-load-more-wrap';
    wrap.innerHTML =
      '<button type="button">Load more diamonds</button>' +
      '<div class="sp-shown"></div>';
    var tbl = document.getElementById(TABLE_ID);
    if (tbl && tbl.parentNode) tbl.parentNode.insertBefore(wrap, tbl.nextSibling);
    var shown = wrap.querySelector('.sp-shown');
    if (shown && totalPages > 0) {
      shown.textContent = 'Showing ' + (lastFetchedPage * 60).toLocaleString() +
        ' of approximately ' + (totalPages * 60).toLocaleString() + ' stones';
    }
    wrap.querySelector('button').addEventListener('click', function () {
      paused = false;
      removeLoadMore();
      // Allow another batch of auto pages
      var checkpoint = lastFetchedPage;
      var stopAt = checkpoint + AUTO_PAGES;
      if (observer) observer.observe(nextPageEl);
      function loop() {
        if (stopped || paused) return;
        if (lastFetchedPage >= totalPages) { stop('all pages loaded'); return; }
        if (lastFetchedPage >= stopAt) { pauseForManualLoad(); return; }
        tryNext().then(function () {
          if (!stopped && !paused) setTimeout(loop, 50);
        });
      }
      loop();
    });
  }

  function removeLoadMore() {
    var w = document.getElementById('sp-load-more-wrap');
    if (w && w.parentNode) w.parentNode.removeChild(w);
  }

  async function tryNext() {
    if (stopped || paused || inFlight) return;
    if (lastFetchedPage >= totalPages && totalPages > 1) return;
    // Auto-pause after AUTO_PAGES to keep DOM tractable
    if (lastFetchedPage >= AUTO_PAGES) {
      pauseForManualLoad();
      return;
    }

    var formEl = document.getElementById('filterform');
    if (!formEl) { console.warn('[auto-paginate] #filterform not found'); return; }

    inFlight = true;
    // Advance counter BEFORE fetch so a failure doesn't trigger retry storm
    var nextPage = lastFetchedPage + 1;
    lastFetchedPage = nextPage;

    // Convert form to plain object → JSON body (simpler than multipart, avoids parsing quirks)
    var payload = {};
    new FormData(formEl).forEach(function (v, k) {
      if (typeof v === 'string') payload[k] = v;
    });

    var url = (window.theme && theme.settings && theme.settings.apiUrl) +
              '/search?page=' + nextPage;
    console.log('[auto-paginate] fetching page', nextPage);

    try {
      var resp = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + btoa('fooPalawat:barPalawat'),
        },
        body: JSON.stringify(payload),
      });
      var bodyText = await resp.text();
      if (!resp.ok) {
        console.warn('[auto-paginate] HTTP', resp.status, '— body:', bodyText.slice(0, 300));
        stop('HTTP ' + resp.status);
        return;
      }
      var json;
      try { json = JSON.parse(bodyText); }
      catch { stop('non-JSON response: ' + bodyText.slice(0, 200)); return; }
      var d = json && json.Diamonds;
      if (!d || !Array.isArray(d.data)) { stop('bad shape: ' + bodyText.slice(0, 200)); return; }
      totalPages = d.last_page || 1;
      console.log('[auto-paginate] page', nextPage, '→', d.data.length, 'records (of', totalPages, 'pages total)');
      if (d.data.length) appendDiamonds(d.data);
      if (lastFetchedPage >= totalPages) stop('all pages loaded');
    } catch (err) {
      console.warn('[auto-paginate] fetch error:', err);
      stop('fetch error');
    } finally {
      inFlight = false;
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function fmt$(n) {
    n = Number(n) || 0;
    if (!n) return '';
    return '$' + n.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function appendDiamonds(items) {
    var html = '';
    items.forEach(function (v) {
      var img = (v.cover_pic || '').indexOf('http') === 0
        ? v.cover_pic
        : ((window.theme && theme.settings && theme.settings.assetUrl) || '') + (v.cover_pic || '');
      var price = v.sale_price > 0 ? v.sale_price : v.original_price;
      var priceStr = fmt$(price) || '';
      var lab = esc(v.lab || '');
      var sku = esc(v.sku || '');
      // Skip unpriced stones entirely — retail site, never expose $0
      if (!priceStr) return;
      var priceHtml = '<span class="main-price">' + priceStr + '</span>';
      html +=
        '<div class="col-md-6 col-lg-6 col-xl-3 col-xxl-3 po-relative mb-2 mt-0" id="diamondcomes' + esc(v.id) + '">' +
          '<div class="diamond-card">' +
            '<a href="/products/diamonds?sku=' + encodeURIComponent(sku) + '" class="card-link" style="text-decoration:none;color:inherit;">' +
              '<div class="image-box">' +
                (img ? '<img src="' + esc(img) + '" loading="lazy" alt="' + esc(v.title) + '" onerror="this.style.display=\'none\'">' : '') +
                (lab ? '<span class="badge rprimarycolor">' + lab + '</span>' : '') +
              '</div>' +
              '<div class="diamond-info">' +
                '<div class="diamond-header">' +
                  '<div class="diamond-shape line-tighter">' + esc(v.shape) + '</div>' +
                  '<div class="diamond-price">' + priceHtml + '</div>' +
                '</div>' +
                '<div class="diamond-details">' +
                  '<div class="detail-item"><span class="detail-value">' + esc(v.carat) + 'ct</span><span class="detail-label">Carat</span></div>' +
                  '<div class="detail-item"><span class="detail-value">' + esc(v.color) + '</span><span class="detail-label">Color</span></div>' +
                  '<div class="detail-item"><span class="detail-value">' + esc(v.clarity) + '</span><span class="detail-label">Clarity</span></div>' +
                  '<div class="detail-item"><span class="detail-value">' + esc(v.cut || '—') + '</span><span class="detail-label">Cut</span></div>' +
                '</div>' +
              '</div>' +
            '</a>' +
          '</div>' +
        '</div>';
    });
    var tbl = document.getElementById(TABLE_ID);
    if (tbl) tbl.insertAdjacentHTML('beforeend', html);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForTable);
  } else {
    waitForTable();
  }
})();
